import React from 'react';
import { FunctionFactory } from 'survey-core';

const consistencySplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">🧩</div>
  <div class="splash-header">
    <h1>That’s very common.</h1>
    <div class="quote">
      Habit building is the key to overcoming inconsistency. Most programs don’t teach this, but we make it easy for you.
    </div>
  </div>
</div>`;

const consistencySplashExpression = {
  name: "consistencyQuote",
  expression: "renderConsistencyQuote({consistency})",
};

function renderConsistencyQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  return "That's very common. Habit building is the key to overcoming this. Most programs don't teach this. We make this easy for you";
}

FunctionFactory.Instance.register("renderConsistencyQuote", renderConsistencyQuote);

const consistencySplashElement = {
  visibleIf: `{consistency} > 3`,
  name: 'consistency-splash',
  type: 'html',
  html: consistencySplashHtml,
}

const ConsistencySplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🔎  Understanding your habits
    </div>
  )
}


export {
  consistencySplashElement,
  consistencySplashExpression,
  ConsistencySplashHeader,
}